import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { AddItemForm } from "./form";
import { langTypeMap } from "../../../../../../shared/Data/langTypeMap";
import { genId } from "../../../../../../shared/utils";
import { useControl } from "../../../../controlContext";
import { useSource, useSourceReducer } from "../../../../sourceContext";

export function ModalAddItem({show, setShow, name}){
  
  const parentKey = useMemo(()=>{
    return langTypeMap[name].getParentKey()
  }, [name])
  const sourceReducer = useSourceReducer()
  const [{[parentKey]:selectedParent}] = useControl()
  const source = useSource()
  const [newCatState, setNewCatState] = useState({})
  const [itemParent, setItemParent] = useState(parentKey ? selectedParent : '')
  
  const confirmDisabled = useMemo(()=>(!langTypeMap[name].getFormSchema().every(itm=>((newCatState[itm.name] && itm.required )|| !itm.required))), [newCatState, name])
  
  useEffect(()=>setItemParent(parentKey ? selectedParent || source[parentKey][0]._id : ''), [selectedParent, parentKey, source])

  function putNewCategory(){
    let newCat
    if(parentKey){
      newCat = new langTypeMap[name]({
        ...newCatState, 
        _id: genId(), 
        [`_${parentKey}`]: itemParent
      })
      console.log('made new category', newCat, source[parentKey].find(itm=>itm[`_${parentKey}`] === newCat[`_${parentKey}`]))
    }else{
      newCat = new langTypeMap[name]({
        ...newCatState, 
        [`_${name}`]: genId(), 
      })
    }
    newCat._name = newCat._id
    newCat._changed = true
    sourceReducer({type:'add_new_item', itemType:name, item:newCat})
    onHide()
  }
  
  function onHide(){
    setShow(false)
    setNewCatState({})
    setItemParent(parentKey ? selectedParent || source[parentKey][0]._id : '')
  }

  // console.log('disabling?', newCatState, langTypeMap, name, parentKey)
  return (
    <Modal show={show} onHide={onHide} size="lg" >
      <Modal.Title>Add New ({name}) Entry</Modal.Title>
      <Modal.Body>
        <AddItemForm 
          name={name} 
          newCatState={newCatState} 
          setNewCatState={setNewCatState} 
          selectedParent={selectedParent} 
          parentKey={parentKey}
          itemParent={itemParent}
          setItemParent={setItemParent}
          source={source}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          disabled={confirmDisabled} 
          onClick={putNewCategory}>Confirm</Button>
        <Button onClick={onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}